unit View.Pdvs.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewPdvsEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbnumero_caixa: TLabel;
    ednumero_caixa: TDBEdit;
    lbnumero_serie_nfce: TLabel;
    ednumero_serie_nfce: TDBEdit;
    lbpdv_ativo: TLabel;
    edpdv_ativo: TDBEdit;
    lbpdv_nfce_sat: TLabel;
    edpdv_nfce_sat: TDBEdit;
    lbpdv_treinamento: TLabel;
    edpdv_treinamento: TDBEdit;
    lbbanco_dados_path: TLabel;
    edbanco_dados_path: TDBEdit;
    lbbanco_dados_host: TLabel;
    edbanco_dados_host: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientPdvsGet: TXDataWebClient;
    XDataClientPdvsDelete: TXDataWebClient;
    PdvsDataset: TXDataWebDataSet;
    PdvsDatasetid: TIntegerField;
    PdvsDatasetaliado_id: TIntegerField;
    PdvsDatasetdata_base_id: TIntegerField;
    PdvsDatasetnome: TStringField;
    PdvsDatasetnumero_caixa: TIntegerField;
    PdvsDatasetnumero_serie_nfce: TIntegerField;
    PdvsDatasetpdv_ativo: TBooleanField;
    PdvsDatasetpdv_nfce_sat: TBooleanField;
    PdvsDatasetpdv_treinamento: TBooleanField;
    PdvsDatasetbanco_dados_path: TStringField;
    PdvsDatasetbanco_dados_host: TStringField;
    PdvsDatasetcodigo_interno: TIntegerField;
    PdvsDatasetexcluido: TBooleanField;
    PdvsDatasetinclusao: TDateTimeField;
    PdvsDatasetalteracao: TDateTimeField;
    PdvsDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientPdvsGetLoad(Response: TXDataClientResponse);
    procedure XDataClientPdvsDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientPdvsDeleteError(Error: TXDataClientError);
    procedure PdvsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewPdvsEdit: TFViewPdvsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPdvsEdit }

procedure TFViewPdvsEdit.btSaveClick(Sender: TObject);
begin
  if PdvsDataset.State in dsEditModes then
  begin
        PdvsDataset.Post;
    PdvsDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewPdvsEdit.btDeleteClick(Sender: TObject);
begin
  if PdvsDataset.State in dsEditModes then
    PdvsDataset.Post;
  XDataClientPdvsDelete.Delete(PdvsDataset.EntitySetName,
    TJSObject(PdvsDataset.CurrentData));
end;


class function TFViewPdvsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewPdvsEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewPdvsEdit.InsertEntity;
begin
  PdvsDataset.Close;
  PdvsDataset.SetJsonData('{}');
  PdvsDataset.Open;
  PdvsDataset.Insert;
end;

class function TFViewPdvsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPdvsEdit(AForm).FInserting := AInserting;
    TFViewPdvsEdit(AForm).FId := AId;
    TFViewPdvsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewPdvsEdit(AForm).InsertEntity
    else
      TFViewPdvsEdit(AForm).LoadEntity;
    TFViewPdvsEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewPdvsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewPdvsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    PdvsDataset.Connection.Model.DefaultSchema.FindEntityType(
      PdvsDataset.EntitySetName
    )
  );
  XDataClientPdvsGet.Get(PdvsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewPdvsEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewPdvsEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPdvsEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewPdvsEdit.XDataClientPdvsGetLoad(Response: TXDataClientResponse);
begin
  PdvsDataset.Close;
  PdvsDataset.SetJsonData(Response.Result);
  PdvsDataset.Open;
  
  PdvsDataset.Edit;  
end;

procedure TFViewPdvsEdit.XDataClientPdvsDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewPdvsEdit.XDataClientPdvsDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewPdvsEdit.PdvsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewPdvsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewPdvsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.pdvs.form.message');
  lbMessage := TLabel.Create('view.pdvs.form.message.label');
  btCloseMessage := TButton.Create('view.pdvs.form.message.button');
  btCancel := TButton.Create('view.pdvs.form.btBack');
  btSave := TButton.Create('view.pdvs.form.btSave');
  btDelete := TButton.Create('view.pdvs.form.btDelete');
  lbid := TLabel.Create('view.pdvs.form.lbid');
  edid := TDBEdit.Create('view.pdvs.form.edid');
  lbaliado_id := TLabel.Create('view.pdvs.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.pdvs.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.pdvs.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.pdvs.form.eddata_base_id');
  lbnome := TLabel.Create('view.pdvs.form.lbnome');
  ednome := TDBEdit.Create('view.pdvs.form.ednome');
  lbnumero_caixa := TLabel.Create('view.pdvs.form.lbnumero_caixa');
  ednumero_caixa := TDBEdit.Create('view.pdvs.form.ednumero_caixa');
  lbnumero_serie_nfce := TLabel.Create('view.pdvs.form.lbnumero_serie_nfce');
  ednumero_serie_nfce := TDBEdit.Create('view.pdvs.form.ednumero_serie_nfce');
  lbpdv_ativo := TLabel.Create('view.pdvs.form.lbpdv_ativo');
  edpdv_ativo := TDBEdit.Create('view.pdvs.form.edpdv_ativo');
  lbpdv_nfce_sat := TLabel.Create('view.pdvs.form.lbpdv_nfce_sat');
  edpdv_nfce_sat := TDBEdit.Create('view.pdvs.form.edpdv_nfce_sat');
  lbpdv_treinamento := TLabel.Create('view.pdvs.form.lbpdv_treinamento');
  edpdv_treinamento := TDBEdit.Create('view.pdvs.form.edpdv_treinamento');
  lbbanco_dados_path := TLabel.Create('view.pdvs.form.lbbanco_dados_path');
  edbanco_dados_path := TDBEdit.Create('view.pdvs.form.edbanco_dados_path');
  lbbanco_dados_host := TLabel.Create('view.pdvs.form.lbbanco_dados_host');
  edbanco_dados_host := TDBEdit.Create('view.pdvs.form.edbanco_dados_host');
  lbcodigo_interno := TLabel.Create('view.pdvs.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.pdvs.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.pdvs.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.pdvs.form.edexcluido');
  lbinclusao := TLabel.Create('view.pdvs.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.pdvs.form.edinclusao');
  lbalteracao := TLabel.Create('view.pdvs.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.pdvs.form.edalteracao');
  lbexclusao := TLabel.Create('view.pdvs.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.pdvs.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  PdvsDataset := TXDataWebDataSet.Create(Self);
  PdvsDatasetid := TIntegerField.Create(Self);
  PdvsDatasetaliado_id := TIntegerField.Create(Self);
  PdvsDatasetdata_base_id := TIntegerField.Create(Self);
  PdvsDatasetnome := TStringField.Create(Self);
  PdvsDatasetnumero_caixa := TIntegerField.Create(Self);
  PdvsDatasetnumero_serie_nfce := TIntegerField.Create(Self);
  PdvsDatasetpdv_ativo := TBooleanField.Create(Self);
  PdvsDatasetpdv_nfce_sat := TBooleanField.Create(Self);
  PdvsDatasetpdv_treinamento := TBooleanField.Create(Self);
  PdvsDatasetbanco_dados_path := TStringField.Create(Self);
  PdvsDatasetbanco_dados_host := TStringField.Create(Self);
  PdvsDatasetcodigo_interno := TIntegerField.Create(Self);
  PdvsDatasetexcluido := TBooleanField.Create(Self);
  PdvsDatasetinclusao := TDateTimeField.Create(Self);
  PdvsDatasetalteracao := TDateTimeField.Create(Self);
  PdvsDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientPdvsGet := TXDataWebClient.Create(Self);
  XDataClientPdvsDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbnumero_caixa.BeforeLoadDFMValues;
  ednumero_caixa.BeforeLoadDFMValues;
  lbnumero_serie_nfce.BeforeLoadDFMValues;
  ednumero_serie_nfce.BeforeLoadDFMValues;
  lbpdv_ativo.BeforeLoadDFMValues;
  edpdv_ativo.BeforeLoadDFMValues;
  lbpdv_nfce_sat.BeforeLoadDFMValues;
  edpdv_nfce_sat.BeforeLoadDFMValues;
  lbpdv_treinamento.BeforeLoadDFMValues;
  edpdv_treinamento.BeforeLoadDFMValues;
  lbbanco_dados_path.BeforeLoadDFMValues;
  edbanco_dados_path.BeforeLoadDFMValues;
  lbbanco_dados_host.BeforeLoadDFMValues;
  edbanco_dados_host.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  PdvsDataset.BeforeLoadDFMValues;
  PdvsDatasetid.BeforeLoadDFMValues;
  PdvsDatasetaliado_id.BeforeLoadDFMValues;
  PdvsDatasetdata_base_id.BeforeLoadDFMValues;
  PdvsDatasetnome.BeforeLoadDFMValues;
  PdvsDatasetnumero_caixa.BeforeLoadDFMValues;
  PdvsDatasetnumero_serie_nfce.BeforeLoadDFMValues;
  PdvsDatasetpdv_ativo.BeforeLoadDFMValues;
  PdvsDatasetpdv_nfce_sat.BeforeLoadDFMValues;
  PdvsDatasetpdv_treinamento.BeforeLoadDFMValues;
  PdvsDatasetbanco_dados_path.BeforeLoadDFMValues;
  PdvsDatasetbanco_dados_host.BeforeLoadDFMValues;
  PdvsDatasetcodigo_interno.BeforeLoadDFMValues;
  PdvsDatasetexcluido.BeforeLoadDFMValues;
  PdvsDatasetinclusao.BeforeLoadDFMValues;
  PdvsDatasetalteracao.BeforeLoadDFMValues;
  PdvsDatasetexclusao.BeforeLoadDFMValues;
  XDataClientPdvsGet.BeforeLoadDFMValues;
  XDataClientPdvsDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewPdvsEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 697;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 637;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 637;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 637;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbnumero_caixa.SetParentComponent(Self);
    lbnumero_caixa.Name := 'lbnumero_caixa';
    lbnumero_caixa.Left := 24;
    lbnumero_caixa.Top := 300;
    lbnumero_caixa.Width := 14;
    lbnumero_caixa.Height := 13;
    lbnumero_caixa.Caption := 'numero_caixa:';
    lbnumero_caixa.Transparent := True;
    ednumero_caixa.SetParentComponent(Self);
    ednumero_caixa.Name := 'ednumero_caixa';
    ednumero_caixa.Left := 221;
    ednumero_caixa.Top := 297;
    ednumero_caixa.Width := 200;
    ednumero_caixa.Height := 21;
    ednumero_caixa.Enabled := True;
    ednumero_caixa.TabOrder := 10;
    ednumero_caixa.Text := 'ednumero_caixa';
    ednumero_caixa.DataField := 'numero_caixa';
    ednumero_caixa.DataSource := DataSource;
    lbnumero_serie_nfce.SetParentComponent(Self);
    lbnumero_serie_nfce.Name := 'lbnumero_serie_nfce';
    lbnumero_serie_nfce.Left := 24;
    lbnumero_serie_nfce.Top := 327;
    lbnumero_serie_nfce.Width := 14;
    lbnumero_serie_nfce.Height := 13;
    lbnumero_serie_nfce.Caption := 'numero_serie_nfce:';
    lbnumero_serie_nfce.Transparent := True;
    ednumero_serie_nfce.SetParentComponent(Self);
    ednumero_serie_nfce.Name := 'ednumero_serie_nfce';
    ednumero_serie_nfce.Left := 221;
    ednumero_serie_nfce.Top := 324;
    ednumero_serie_nfce.Width := 200;
    ednumero_serie_nfce.Height := 21;
    ednumero_serie_nfce.Enabled := True;
    ednumero_serie_nfce.TabOrder := 11;
    ednumero_serie_nfce.Text := 'ednumero_serie_nfce';
    ednumero_serie_nfce.DataField := 'numero_serie_nfce';
    ednumero_serie_nfce.DataSource := DataSource;
    lbpdv_ativo.SetParentComponent(Self);
    lbpdv_ativo.Name := 'lbpdv_ativo';
    lbpdv_ativo.Left := 24;
    lbpdv_ativo.Top := 354;
    lbpdv_ativo.Width := 14;
    lbpdv_ativo.Height := 13;
    lbpdv_ativo.Caption := 'pdv_ativo:';
    lbpdv_ativo.Transparent := True;
    edpdv_ativo.SetParentComponent(Self);
    edpdv_ativo.Name := 'edpdv_ativo';
    edpdv_ativo.Left := 221;
    edpdv_ativo.Top := 351;
    edpdv_ativo.Width := 200;
    edpdv_ativo.Height := 21;
    edpdv_ativo.Enabled := True;
    edpdv_ativo.TabOrder := 12;
    edpdv_ativo.Text := 'edpdv_ativo';
    edpdv_ativo.DataField := 'pdv_ativo';
    edpdv_ativo.DataSource := DataSource;
    lbpdv_nfce_sat.SetParentComponent(Self);
    lbpdv_nfce_sat.Name := 'lbpdv_nfce_sat';
    lbpdv_nfce_sat.Left := 24;
    lbpdv_nfce_sat.Top := 381;
    lbpdv_nfce_sat.Width := 14;
    lbpdv_nfce_sat.Height := 13;
    lbpdv_nfce_sat.Caption := 'pdv_nfce_sat:';
    lbpdv_nfce_sat.Transparent := True;
    edpdv_nfce_sat.SetParentComponent(Self);
    edpdv_nfce_sat.Name := 'edpdv_nfce_sat';
    edpdv_nfce_sat.Left := 221;
    edpdv_nfce_sat.Top := 378;
    edpdv_nfce_sat.Width := 200;
    edpdv_nfce_sat.Height := 21;
    edpdv_nfce_sat.Enabled := True;
    edpdv_nfce_sat.TabOrder := 13;
    edpdv_nfce_sat.Text := 'edpdv_nfce_sat';
    edpdv_nfce_sat.DataField := 'pdv_nfce_sat';
    edpdv_nfce_sat.DataSource := DataSource;
    lbpdv_treinamento.SetParentComponent(Self);
    lbpdv_treinamento.Name := 'lbpdv_treinamento';
    lbpdv_treinamento.Left := 24;
    lbpdv_treinamento.Top := 408;
    lbpdv_treinamento.Width := 14;
    lbpdv_treinamento.Height := 13;
    lbpdv_treinamento.Caption := 'pdv_treinamento:';
    lbpdv_treinamento.Transparent := True;
    edpdv_treinamento.SetParentComponent(Self);
    edpdv_treinamento.Name := 'edpdv_treinamento';
    edpdv_treinamento.Left := 221;
    edpdv_treinamento.Top := 405;
    edpdv_treinamento.Width := 200;
    edpdv_treinamento.Height := 21;
    edpdv_treinamento.Enabled := True;
    edpdv_treinamento.TabOrder := 14;
    edpdv_treinamento.Text := 'edpdv_treinamento';
    edpdv_treinamento.DataField := 'pdv_treinamento';
    edpdv_treinamento.DataSource := DataSource;
    lbbanco_dados_path.SetParentComponent(Self);
    lbbanco_dados_path.Name := 'lbbanco_dados_path';
    lbbanco_dados_path.Left := 24;
    lbbanco_dados_path.Top := 435;
    lbbanco_dados_path.Width := 14;
    lbbanco_dados_path.Height := 13;
    lbbanco_dados_path.Caption := 'banco_dados_path:';
    lbbanco_dados_path.Transparent := True;
    edbanco_dados_path.SetParentComponent(Self);
    edbanco_dados_path.Name := 'edbanco_dados_path';
    edbanco_dados_path.Left := 221;
    edbanco_dados_path.Top := 432;
    edbanco_dados_path.Width := 200;
    edbanco_dados_path.Height := 21;
    edbanco_dados_path.Enabled := True;
    edbanco_dados_path.TabOrder := 15;
    edbanco_dados_path.Text := 'edbanco_dados_path';
    edbanco_dados_path.DataField := 'banco_dados_path';
    edbanco_dados_path.DataSource := DataSource;
    lbbanco_dados_host.SetParentComponent(Self);
    lbbanco_dados_host.Name := 'lbbanco_dados_host';
    lbbanco_dados_host.Left := 24;
    lbbanco_dados_host.Top := 462;
    lbbanco_dados_host.Width := 14;
    lbbanco_dados_host.Height := 13;
    lbbanco_dados_host.Caption := 'banco_dados_host:';
    lbbanco_dados_host.Transparent := True;
    edbanco_dados_host.SetParentComponent(Self);
    edbanco_dados_host.Name := 'edbanco_dados_host';
    edbanco_dados_host.Left := 221;
    edbanco_dados_host.Top := 459;
    edbanco_dados_host.Width := 200;
    edbanco_dados_host.Height := 21;
    edbanco_dados_host.Enabled := True;
    edbanco_dados_host.TabOrder := 16;
    edbanco_dados_host.Text := 'edbanco_dados_host';
    edbanco_dados_host.DataField := 'banco_dados_host';
    edbanco_dados_host.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 489;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 486;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 17;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 516;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 513;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 18;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 543;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 540;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 19;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 570;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 567;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 20;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 597;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 594;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 21;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := PdvsDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    PdvsDataset.SetParentComponent(Self);
    PdvsDataset.Name := 'PdvsDataset';
    PdvsDataset.AfterApplyUpdates := PdvsDatasetAfterApplyUpdates;
    PdvsDataset.EntitySetName := 'Pdvs';
    PdvsDataset.Connection := DMConnection.ApiConnection;
    PdvsDataset.Left := 176;
    PdvsDataset.Top := 8;
    PdvsDatasetid.SetParentComponent(PdvsDataset);
    PdvsDatasetid.Name := 'PdvsDatasetid';
    PdvsDatasetid.FieldName := 'id';
    PdvsDatasetid.Required := True;
    PdvsDatasetaliado_id.SetParentComponent(PdvsDataset);
    PdvsDatasetaliado_id.Name := 'PdvsDatasetaliado_id';
    PdvsDatasetaliado_id.FieldName := 'aliado_id';
    PdvsDatasetaliado_id.Required := True;
    PdvsDatasetdata_base_id.SetParentComponent(PdvsDataset);
    PdvsDatasetdata_base_id.Name := 'PdvsDatasetdata_base_id';
    PdvsDatasetdata_base_id.FieldName := 'data_base_id';
    PdvsDatasetdata_base_id.Required := True;
    PdvsDatasetnome.SetParentComponent(PdvsDataset);
    PdvsDatasetnome.Name := 'PdvsDatasetnome';
    PdvsDatasetnome.FieldName := 'nome';
    PdvsDatasetnome.Required := False;
    PdvsDatasetnome.Size := 255;
    PdvsDatasetnumero_caixa.SetParentComponent(PdvsDataset);
    PdvsDatasetnumero_caixa.Name := 'PdvsDatasetnumero_caixa';
    PdvsDatasetnumero_caixa.FieldName := 'numero_caixa';
    PdvsDatasetnumero_caixa.Required := False;
    PdvsDatasetnumero_serie_nfce.SetParentComponent(PdvsDataset);
    PdvsDatasetnumero_serie_nfce.Name := 'PdvsDatasetnumero_serie_nfce';
    PdvsDatasetnumero_serie_nfce.FieldName := 'numero_serie_nfce';
    PdvsDatasetnumero_serie_nfce.Required := False;
    PdvsDatasetpdv_ativo.SetParentComponent(PdvsDataset);
    PdvsDatasetpdv_ativo.Name := 'PdvsDatasetpdv_ativo';
    PdvsDatasetpdv_ativo.FieldName := 'pdv_ativo';
    PdvsDatasetpdv_ativo.Required := True;
    PdvsDatasetpdv_nfce_sat.SetParentComponent(PdvsDataset);
    PdvsDatasetpdv_nfce_sat.Name := 'PdvsDatasetpdv_nfce_sat';
    PdvsDatasetpdv_nfce_sat.FieldName := 'pdv_nfce_sat';
    PdvsDatasetpdv_nfce_sat.Required := True;
    PdvsDatasetpdv_treinamento.SetParentComponent(PdvsDataset);
    PdvsDatasetpdv_treinamento.Name := 'PdvsDatasetpdv_treinamento';
    PdvsDatasetpdv_treinamento.FieldName := 'pdv_treinamento';
    PdvsDatasetpdv_treinamento.Required := True;
    PdvsDatasetbanco_dados_path.SetParentComponent(PdvsDataset);
    PdvsDatasetbanco_dados_path.Name := 'PdvsDatasetbanco_dados_path';
    PdvsDatasetbanco_dados_path.FieldName := 'banco_dados_path';
    PdvsDatasetbanco_dados_path.Required := False;
    PdvsDatasetbanco_dados_path.Size := 255;
    PdvsDatasetbanco_dados_host.SetParentComponent(PdvsDataset);
    PdvsDatasetbanco_dados_host.Name := 'PdvsDatasetbanco_dados_host';
    PdvsDatasetbanco_dados_host.FieldName := 'banco_dados_host';
    PdvsDatasetbanco_dados_host.Required := False;
    PdvsDatasetbanco_dados_host.Size := 255;
    PdvsDatasetcodigo_interno.SetParentComponent(PdvsDataset);
    PdvsDatasetcodigo_interno.Name := 'PdvsDatasetcodigo_interno';
    PdvsDatasetcodigo_interno.FieldName := 'codigo_interno';
    PdvsDatasetcodigo_interno.Required := True;
    PdvsDatasetexcluido.SetParentComponent(PdvsDataset);
    PdvsDatasetexcluido.Name := 'PdvsDatasetexcluido';
    PdvsDatasetexcluido.FieldName := 'excluido';
    PdvsDatasetexcluido.Required := False;
    PdvsDatasetinclusao.SetParentComponent(PdvsDataset);
    PdvsDatasetinclusao.Name := 'PdvsDatasetinclusao';
    PdvsDatasetinclusao.FieldName := 'inclusao';
    PdvsDatasetinclusao.Required := False;
    PdvsDatasetalteracao.SetParentComponent(PdvsDataset);
    PdvsDatasetalteracao.Name := 'PdvsDatasetalteracao';
    PdvsDatasetalteracao.FieldName := 'alteracao';
    PdvsDatasetalteracao.Required := False;
    PdvsDatasetexclusao.SetParentComponent(PdvsDataset);
    PdvsDatasetexclusao.Name := 'PdvsDatasetexclusao';
    PdvsDatasetexclusao.FieldName := 'exclusao';
    PdvsDatasetexclusao.Required := False;
    XDataClientPdvsGet.SetParentComponent(Self);
    XDataClientPdvsGet.Name := 'XDataClientPdvsGet';
    XDataClientPdvsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPdvsGet, Self, 'OnLoad', 'XDataClientPdvsGetLoad');
    XDataClientPdvsGet.Left := 64;
    XDataClientPdvsGet.Top := 8;
    XDataClientPdvsDelete.SetParentComponent(Self);
    XDataClientPdvsDelete.Name := 'XDataClientPdvsDelete';
    XDataClientPdvsDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientPdvsDelete, Self, 'OnLoad', 'XDataClientPdvsDeleteLoad');
    SetEvent(XDataClientPdvsDelete, Self, 'OnError', 'XDataClientPdvsDeleteError');
    XDataClientPdvsDelete.Left := 64;
    XDataClientPdvsDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbnumero_caixa.AfterLoadDFMValues;
    ednumero_caixa.AfterLoadDFMValues;
    lbnumero_serie_nfce.AfterLoadDFMValues;
    ednumero_serie_nfce.AfterLoadDFMValues;
    lbpdv_ativo.AfterLoadDFMValues;
    edpdv_ativo.AfterLoadDFMValues;
    lbpdv_nfce_sat.AfterLoadDFMValues;
    edpdv_nfce_sat.AfterLoadDFMValues;
    lbpdv_treinamento.AfterLoadDFMValues;
    edpdv_treinamento.AfterLoadDFMValues;
    lbbanco_dados_path.AfterLoadDFMValues;
    edbanco_dados_path.AfterLoadDFMValues;
    lbbanco_dados_host.AfterLoadDFMValues;
    edbanco_dados_host.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    PdvsDataset.AfterLoadDFMValues;
    PdvsDatasetid.AfterLoadDFMValues;
    PdvsDatasetaliado_id.AfterLoadDFMValues;
    PdvsDatasetdata_base_id.AfterLoadDFMValues;
    PdvsDatasetnome.AfterLoadDFMValues;
    PdvsDatasetnumero_caixa.AfterLoadDFMValues;
    PdvsDatasetnumero_serie_nfce.AfterLoadDFMValues;
    PdvsDatasetpdv_ativo.AfterLoadDFMValues;
    PdvsDatasetpdv_nfce_sat.AfterLoadDFMValues;
    PdvsDatasetpdv_treinamento.AfterLoadDFMValues;
    PdvsDatasetbanco_dados_path.AfterLoadDFMValues;
    PdvsDatasetbanco_dados_host.AfterLoadDFMValues;
    PdvsDatasetcodigo_interno.AfterLoadDFMValues;
    PdvsDatasetexcluido.AfterLoadDFMValues;
    PdvsDatasetinclusao.AfterLoadDFMValues;
    PdvsDatasetalteracao.AfterLoadDFMValues;
    PdvsDatasetexclusao.AfterLoadDFMValues;
    XDataClientPdvsGet.AfterLoadDFMValues;
    XDataClientPdvsDelete.AfterLoadDFMValues;
  end;
end;

end.
